"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteToAppStatusChip = void 0;
const InviteToAppStatus_1 = require("@opsbase/lib-auth/InviteToAppStatus");
const react_1 = __importDefault(require("react"));
const Chip_1 = __importDefault(require("../Chip"));
function InviteToAppStatusChip(props) {
    const { inviteToAppStatus } = props;
    return (react_1.default.createElement(Chip_1.default, { small: true, label: (0, InviteToAppStatus_1.inviteToAppStatusLabel)(inviteToAppStatus), color: (0, InviteToAppStatus_1.inviteToAppStatusColor)(inviteToAppStatus) }));
}
exports.InviteToAppStatusChip = InviteToAppStatusChip;
exports.default = InviteToAppStatusChip;
